function identity(a) { return a; }

// fns muze obsahovat tyto funkce:
// - fwd(value, inst): slouzi k vypoctu hodnoty noveho inputu ze stareho, vc. atributu min, max a step
// - bwd(value, inst): slouzi k vypoctu hodnoty stareho inputu z noveho
// - init(inst): slouzi k cemukoliv, je volano po nastaveni vseho
//
// inst je objekt { newEl, el, update }, kde update je funkce, ktera aktualizuje atributy noveho inputu (min, max, step, value)
// - use case: kdyz se nekde zmeni parametry prepoctu fwd a bwd, chci zavolat update
export function rangeMirror(el, fns) {
  var $el = $(el);
  var newEl = document.getElementById(el.id+"_mirror");
  if(!newEl) {
    newEl = document.createElement("input");
    newEl.type = "number";
    // newEl.className= "nummirror";
    $el.after(newEl);
  }

  var $newEl = $(newEl);

  var fwdFn = fns && fns.fwd || identity;
  var bwdFn = fns && fns.bwd || identity;

  var inst = {
    update: function() {
      newEl.min = fwdFn(el.min, inst);
      newEl.max = fwdFn(el.max, inst);
      newEl.step = Math.max(fwdFn(el.step, inst), 1e-3);
      newEl.value = fwdFn(el.value, inst);
      newEl.setAttribute("value", Number(el.getAttribute("value")));
    },
    el: el,
    newEl: newEl
  };

  inst.update();

  $el.on("input change", function($evt, data) {
    if(data && data.ignore) return;
    newEl.value = fwdFn(el.value, inst);
  });

  $newEl.on("input", function() {
    el.value = bwdFn(newEl.value, inst);
    $(el).trigger("input", {ignore: true});
  });

  $newEl.on("change", function() {
    el.value = bwdFn(newEl.value, inst);
    $(el).trigger("change", {ignore: true});
  });

  if(fns && fns.init) fns.init(inst);
}